import { cn } from "@/lib/utils";

export function BloomCard({ className, interactive = false, children, ...props }) {
  return (
    <div
      className={cn(
        "rounded-3xl border border-border bg-card p-6 shadow-soft md:p-7",
        interactive &&
          "cursor-pointer transition-all duration-300 ease-bounce hover:-translate-y-1.5 hover:border-primary/40 hover:shadow-soft-lg",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default BloomCard;
